import React from 'react';
import Styles from './centerText-styles.scss';
export const CenterText = ({ title, amount }) => {
    return (React.createElement("div", { className: Styles.centerTextContainer },
        React.createElement("h4", null, title),
        React.createElement("h3", null, amount)));
};
